import { createContext, useContext } from "react";

export type DispatchFn = (
  action: string,
  params?: Record<string, unknown>,
) => void;

export const NomniDispatch = createContext<DispatchFn>(() => {});

export function useNomniDispatch(): DispatchFn {
  return useContext(NomniDispatch);
}
